const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case "SALUTATION_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "SALUTATION_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "SALUTATION_SUCCESS":
			return {
				...state,
				salutations: action.data.salutations,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/salutations.js